var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29262_19970)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1917 5.46491C21.3792 5.65243 21.4845 5.90674 21.4845 6.17191C21.4845 6.43707 21.3792 6.69138 21.1917 6.87891L9.9497 18.1219C9.84755 18.2241 9.72627 18.3052 9.59278 18.3605C9.45928 18.4158 9.3162 18.4443 9.1717 18.4443C9.02721 18.4443 8.88413 18.4158 8.75063 18.3605C8.61714 18.3052 8.49586 18.2241 8.3937 18.1219L2.8077 12.5359C2.71479 12.443 2.64109 12.3327 2.59081 12.2113C2.54053 12.0899 2.51465 11.9598 2.51465 11.8284C2.51465 11.697 2.54053 11.5669 2.59081 11.4455C2.64109 11.3241 2.71479 11.2138 2.8077 11.1209C2.90061 11.028 3.01092 10.9543 3.13231 10.904C3.2537 10.8537 3.38381 10.8278 3.5152 10.8278C3.6466 10.8278 3.77671 10.8537 3.8981 10.904C4.01949 10.9543 4.12979 11.028 4.2227 11.1209L9.1727 16.0709L19.7767 5.46491C19.9642 5.27743 20.2185 5.17212 20.4837 5.17212C20.7489 5.17212 21.0042 5.27743 21.1917 5.46491Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29262_19970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkBlack);
export default __webpack_public_path__ + "static/media/mark-black.52a5bb05c08aec5881c66d3ffdb8938e.svg";
export { ForwardRef as ReactComponent };